import React from 'react';
import BottomNav from '../components/BottomNav';
import AppNav from '../components/AppNav';
import { Outlet} from 'react-router-dom';

function HighSchoolLayout() {
  return (
    <>
      <AppNav/>
      <main>
        <Outlet /> 
      </main>
      <BottomNav />
    </>
  );
}

export default HighSchoolLayout;
